//https://github.com/8Tesla8/utc-to-local-time/blob/main/src/app/utc-pipe/utc-to-local-time.pipe.ts
//All Dates will be stored in databases as UTC because code will be running on servers in Azure.

export enum UtcToLocalTimeFormat {
    FULL = "full", // 'EEEE, MMMM d, y, h:mm:ss a zzzz'   - Monday, June 15, 2015 at 9:03:01 AM GMT+01:00
    SHORT = "short", // 'd/M/yy, h:mm'                      - 15/6/15, 9:03
    SHORT_DATE = "shortDate", // 'd/M/yy'                            - 15/6/15
    SHORT_TIME = "shortTime", // 'h:mm'                              - 9:03
}

export class UtcConverterService {
    public convertUtcToLocalTime(
        utcDate?: string, // UTC ISO-8601
        format: UtcToLocalTimeFormat = UtcToLocalTimeFormat.FULL
    ): string {
        //const browserLanguage = navigator.language;
        if (utcDate === null) {
            return '';
        }
        const utcDatez = new Date(utcDate + "Z");
        // add 'Z' to the date to indicate timezone is included in the date.
        if (format === UtcToLocalTimeFormat.SHORT) {
            //const date = new Date(utcDate + "Z").toDateString(); //.toLocaleDateString(browserLanguage);
            let ts = new Intl.DateTimeFormat("en-CA", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                //second: "2-digit",
                hour12: true,
                
            }).format(utcDatez);
            //const time = new Date(utcDate + "Z").toTimeString(); //.toLocaleTimeString(browserLanguage);
            //return `${date}, ${ts}`;
            ts = ts.replace(',',' ').replaceAll('.','').toUpperCase();   //remove the comma, since excel will see the date as a date
            return `${ts}`;
        } else if (format === UtcToLocalTimeFormat.SHORT_DATE) {

              let ts = new Intl.DateTimeFormat("en-CA", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(utcDatez);
            //const time = new Date(utcDate + "Z").toTimeString(); //.toLocaleTimeString(browserLanguage);
            //return `${date}, ${ts}`;
            ts = ts.replaceAll('.','');   //remove the comma, since excel will see the date as a date
            return `${ts}`;

           // return new Date(utcDate!).toDateString(); //.toLocaleDateString(browserLanguage);
        } else if (format === UtcToLocalTimeFormat.SHORT_TIME) {
            return new Date(utcDate + "Z").toTimeString(); // .toLocaleTimeString(browserLanguage);
        } else if (format === UtcToLocalTimeFormat.FULL) {
            return new Date(utcDate + "Z").toString();
        } else {
            console.error(`Do not have logic to format utc date, format:${format}`);
            return new Date(utcDate ||'').toString();
        }
    }

    /*
    public convertLocalTimeToUtc(localDate: string): string {
        const date = new Date(localDate);
        return date.toUTCString();
    }
    */

    public convertLocalDateToUTCIgnoringTimezone(date: Date) {
        const timestamp = Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
          date.getMilliseconds(),
        );
      
        return new Date(timestamp);
      } 

    public convertUTCToLocalDateIgnoringTimezone(utcDate: Date) {
        return new Date(
          utcDate.getUTCFullYear(),
          utcDate.getUTCMonth(),
          utcDate.getUTCDate(),
          utcDate.getUTCHours(),
          utcDate.getUTCMinutes(),
          utcDate.getUTCSeconds(),
          utcDate.getUTCMilliseconds(),
        )
    }

    titleCaseString(input: string) : string {
        const result = input.replace(/([A-Z])/g, " $1");
        const titleCase = result.charAt(0).toUpperCase() + result.slice(1);
        return titleCase.trim();
    }




}
